import styles from './styles.module.scss';

const Loader = () => {
  return (
    <div className={styles.skCubeGrid}>
      <div className={[styles.skCube, styles.skCube1].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube2].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube3].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube4].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube5].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube6].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube7].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube8].join(' ')}></div>
      <div className={[styles.skCube, styles.skCube9].join(' ')}></div>
    </div>
  );
};

export default Loader;
